var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{class:{'clickable': _vm.$can('edit', 'YachtManufacturer')}},[_c('td',[_vm._v(" "+_vm._s(_vm.yachtManufacturer.name)+" ")]),_c('td',[_vm._v(" "+_vm._s(_vm.yachtManufacturer.country.name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }